<app-cardpage-base [loading]="loading">
  <p-card class="card-layout block h-full min-h-0 w-full"
          styleClass="flex h-full min-h-0 flex-col">
    <ng-template #title>
      <div class="grid grid-cols-2 content-center gap-4">
        <span class="text-xl font-bold">{{ 'titles.dashboardAdmin' | translate }}</span>
        <div class="flex flex-row gap-4 justify-self-end">
          @if(isSuperAdmin) {
          <p-button variant="outlined" icon="pi pi-warehouse" [label]="'newOrg' | translate" (click)="onNewOrg()" />
          }
          <p-button variant="outlined" icon="pi pi-sitemap" [label]="'newDept' | translate" (click)="onNewDept()" />
          <p-button variant="outlined" icon="pi pi-user-plus" [label]="'newUser' | translate" (click)="onNewUser()" />
        </div>
      </div>
    </ng-template>
    <ng-template #subtitle>
      <div class="flex flex-row items-center gap-4">
        <p-select [options]="organizationOptions" optionLabel="value" [(ngModel)]="selectedOrganization" (onChange)="onOrganizationChange($event)" class="col-span-2 text-left" appendTo="body" />
        <span class="text-base">{{ 'titles.dashboardAdminSub' | translate:{ departments: dashboard.departments, users: dashboard.totalUsers } }}</span>
      </div>
    </ng-template>

    <div class="flex w-full flex-col gap-4 pb-4">
      <div class="grid gap-4"
           [ngClass]="isSuperAdmin ? 'grid-cols-6' : 'grid-cols-5'">
        <p-panel [header]="'enabledUsers' | translate" class="text-sm">
          <span class="text-xl font-bold">{{ dashboard.activeUsers }}</span>
        </p-panel>

        @if(isSuperAdmin) {
        <p-panel [header]="'superAdmin' | translate" class="text-sm">
          <span class="text-xl font-bold">{{ dashboard.superAdmin }}</span>
        </p-panel>
        }

        <p-panel [header]="'admins' | translate" class="text-sm">
          <span class="text-xl font-bold">{{ dashboard.admin }}</span>
        </p-panel>
        <p-panel [header]="'clinicians' | translate" class="text-sm">
          <span class="text-xl font-bold">{{ dashboard.clinician }}</span>
        </p-panel>
        <p-panel [header]="'researchers' | translate" class="text-sm">
          <span class="text-xl font-bold">{{ dashboard.research }}</span>
        </p-panel>
        <p-panel [header]="'patients' | translate" class="text-sm">
          <span class="text-xl font-bold">{{ dashboard.patient }}</span>
        </p-panel>
      </div>

      <div class="grid grid-cols-1">
        <p-table [value]="dashboard.users"
                 [paginator]="true" [rows]="8"
                 [scrollable]="true" scrollHeight="flex"
                 sortField="logInfo" [sortOrder]="-1" sortMode="single" removeableSort
                 stripedRows
                 class="flex h-full min-h-0 flex-col">
          <ng-template #header>
            <tr>
              <th pSortableColumn="name">
                <div class="flex items-center gap-2">
                  {{ 'name' | translate }}
                  <p-sort-icon field="name" />
                </div>
              </th>
              <th>
                <div class="flex items-center justify-center">
                  {{ 'department' | translate }}
                </div>
              </th>
              <th pSortableColumn="logInfo">
                <div class="flex items-center justify-center gap-2">
                  {{ 'lastAccess' | translate }}
                  <p-sort-icon field="logInfo" />
                </div>
              </th>
              <th>
                <div class="flex items-center justify-center gap-2">
                  {{ 'role' | translate }}
                  <p-column-filter field="roles" matchMode="arrayHasRole" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                    <ng-template #filter let-value let-filter="filterCallback">
                      <p-select [ngModel]="value" [options]="roleOptions()" (onChange)="filter($event.value)" placeholder="Select One" class="w-full"
                                optionLabel="value" optionValue="id">
                        <ng-template let-option #item>
                          <p-tag [value]="option.value" [severity]="getRoleSeverity(option.id)" />
                        </ng-template>
                      </p-select>
                    </ng-template>
                  </p-column-filter>
                </div>
              </th>
              <th style="width:5%"></th>
            </tr>
          </ng-template>
          <ng-template #body let-user>
            <tr app-user-status-row [user]="user" [isShowing]="isShowing" [maxRole]="maxRole"
                                    (showRequest)="onShowUser($event)">
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="gap 4 grid grid-cols-2">
        <p-table [value]="dashboard.services"
                 [paginator]="true" [rows]="8"
                 [scrollable]="true" scrollHeight="flex"
                 sortField="status" [sortOrder]="1" sortMode="single" removeableSort
                 stripedRows
                 class="flex h-full min-h-0 flex-col">
          <ng-template #header>
            <tr>
              <th style="width:15%" pSortableColumn="department">
                <div class="flex items-center gap-2">
                  {{ 'department' | translate }}
                  <p-sort-icon field="department" />
                </div>
              </th>
              <th style="width:40%" pSortableColumn="serviceId">
                <div class="flex items-center gap-2">
                  {{ 'service' | translate }}
                  <p-sort-icon field="serviceId" />
                </div>
              </th>
              <th style="width:20%" pSortableColumn="status">
                <div class="flex items-center gap-2">
                  {{ 'status' | translate }}
                  <p-sort-icon field="status" />
                </div>
              </th>
              <th style="width:15%">{{ 'notes' | translate }}</th>
              <th style="width:10%"></th>
            </tr>
          </ng-template>
          <ng-template #body let-service>
            <tr>
              <td>{{ service.department }}</td>
              <td [innerHTML]="getServiceName(service.serviceId) | translate"></td>
              <td>
                <p-tag [value]="getServiceStatusName(service.status) | translate" [severity]="getServiceStatusSeverity(service.status)" />
              </td>
              <td>{{ service.note }}</td>
              <td class="flex items-center justify-end">
                @if(isSuperAdmin) {
                <p-button icon="pi pi-user-edit" (click)="onShowService(service)" />
                }
              </td>
            </tr>
          </ng-template>

        </p-table>
      </div>
    </div>
  </p-card>

  <app-department-dialog [isNew]="true"
                         [messageService]="messageService"
                         [(visible)]="showDialogDept"
                         [department]="newDept"
                         (saved)="onDepartmentSaved($event)">
  </app-department-dialog>

  <app-organization-dialog [isNew]="true"
                           [messageService]="messageService"
                           [(visible)]="showDialogOrg"
                           [organization]="newOrg"
                           (saved)="onOrgSaved($event)">
  </app-organization-dialog>

  <app-service-dialog [messageService]="messageService"
                      [(visible)]="showDialogService"
                      [service]="selectedService"
                      (saved)="onServiceSaved($event)">
  </app-service-dialog>

  <app-user-dialog [isNew]="isNewUser"
                   [messageService]="messageService"
                   [(visible)]="showDialogUser"
                   [user]="newUser"
                   (saved)="onUserSaved($event)">
  </app-user-dialog>

</app-cardpage-base>
